<div class="footer" style=" background-image: url('../../assets/images/images/Footer-Ghost-Logo.png');">
  <div class="w-container d-flex">
    <div class="col-12 col-md-6 px-0">
      <img src="assets/images/N2Xpress-Logo.svg" loading="lazy" width="125" alt="" class="image">
      <div>
        <div class="text-block custom-footer-text-box">Send money across borders,<br>the easy way.<br></div>
      </div>
      <div class="div-block-35">
        <div class="div-block-37"><img src="assets/images/masterCardSecureCode.png" loading="lazy" width="48" sizes="(max-width: 479px) 100vw, 48px" srcset="assets/images/masterCardSecureCode-p-500.png 500w, assets/images/masterCardSecureCode.png 1078w" alt="n2xpress - Send money across borders, the easy way - Master Card "></div>
        <div class="div-block-36"><img style="width: 39px!important;" src="assets/images/visa-footer.PNG" loading="lazy" width="48" sizes="(max-width: 479px) 20vw, 48px"  alt="n2xpress - Send money across borders, the easy way - Visa Card" class="image-18"></div>
      </div>
    </div>
    <div class="col-md-6 d-none d-md-flex align-items-center justify-content-end">
      <a target="_blank" href="https://play.google.com/store/apps/details?id=com.n2xpress.app"><img src="assets/images/google-play.png"  class="footer-playStore" alt=""></a> 
      <a class="cursor-pointer" href="https://apps.apple.com/in/app/n2xpress-money-transfer/id1570971775" target="blank"> 
        <img  src="assets/images/apple_store.png" class="footer-appleStore  m-1" alt="">
      </a>
    </div>
  </div>
  <div class="container-4 w-container d-flex flex-row">
    <div class="footer-left custom-footer-left d-flex flex-row d-md-block">
     
      <div class="">
        <div class="row">
          <div class="col-md-8">
            <div class="row pl-3">
              <div class="col-md-3 mt-3">
                <div class="row">
                  <h6 class="primary-text sm-16 font-weight-bold my-3 ">Company</h6>
                </div>
                <div class="row">
                  <a [routerLink]="['/about']" class="custom-footer-link w-inline-block">
                    <div class="text-block-29">About</div>
                  </a>
                </div>
                <div class="row">
                  <a href="https://blog.n2xpress.com/" class="custom-footer-link w-inline-block">
                    <div class="text-block-29">Blog</div>
                  </a>
                </div>
                <div class="row">
                  <a routerLink="/locations" class="custom-footer-link w-inline-block">
                    <div class="text-block-29">Our locations</div>
                  </a>
                </div>
                <div class="row">
                  <a routerLink="/frequently-asked-questions" class="custom-footer-link w-inline-block">
                    <div class="text-block-29">FAQ</div>
                  </a>
                </div>
                <div class="row">
                  <a routerLink="/terms-and-conditions" class="custom-footer-link w-inline-block">
                    <div class="text-block-29">Terms & Conditions</div>
                  </a>
                </div>
              </div>
              <div class="col-md-4 mt-3 d-none d-md-block">
                <div class="row">
                  <h6 class="primary-text sm-16 font-weight-bold my-3">Send money</h6>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <a [routerLink]="['/cad-to-inr']" class="custom-footer-link w-inline-block">
                        <div class="text-block-29">CAD to INR</div>
                      </a>
                    </div>
                    <div class="row">
                      <a [routerLink]="['/cad-to-ngn']" class="custom-footer-link w-inline-block">
                        <div class="text-block-29">CAD to NGN</div>
                      </a>
                    </div>
                    <div class="row">
                      <a [routerLink]="['/cad-to-kes']" class="custom-footer-link w-inline-block">
                        <div class="text-block-29">CAD to KES</div>
                      </a>
                    </div>
                    <div class="row">
                      <a [routerLink]="['/cad-to-ghs']" class="custom-footer-link w-inline-block">
                        <div class="text-block-29">CAD to GHS</div>
                      </a>
                    </div>
                    <div class="row">
                      <a [routerLink]="['/cad-to-xof']" class="custom-footer-link w-inline-block">
                        <div class="text-block-29">CAD to XOF</div>
                      </a>
                    </div>
                    <div class="row">
                      <a [routerLink]="['/cad-to-php']" class="custom-footer-link w-inline-block">
                        <div class="text-block-29">CAD to PHP</div>
                      </a>
                    </div>
                    <div class="row">
                      <a [routerLink]="['/cad-to-zar']" class="custom-footer-link w-inline-block">
                        <div class="text-block-29">CAD to ZAR</div>
                      </a>
                    </div>
                  </div>
                  <!-- <div class="col-md-6"> -->
                    <!-- <div class="row">
                      <a [routerLink]="['/usd-to-inr']" class="custom-footer-link w-inline-block">
                        <div class="text-block-29">USD to INR</div>
                      </a>
                    </div> -->
                    <!-- <div class="row">
                      <a [routerLink]="['/usd-to-ghs']" class="custom-footer-link w-inline-block">
                        <div class="text-block-29">USD to GHS</div>
                      </a>
                    </div> -->
                    <!-- <div class="row">
                      <a [routerLink]="['/usd-to-kes']" class="custom-footer-link w-inline-block">
                        <div class="text-block-29">USD to KES</div>
                      </a>
                    </div> -->
                  <!-- </div> -->
                </div>
              </div>
              <div class="col-md-3 mt-3">
                <div class="row">
                  <h6 class="primary-text sm-16 font-weight-bold my-3">Pay bills</h6>
                </div>
                <div class="row">
                  <a [routerLink]="['/pay-bills']" class="custom-footer-link w-inline-block">
                    <div class="text-block-29">Pay bills</div>
                  </a>
                </div>
              </div>
            </div>
        
          </div>
        </div>
        <div class="footer-link-panel-social">
          <h6 class="primary-text sm-16 font-weight-bold mt-4">Connect with us</h6>
          <div class="div-block-22 mt-2">
            <a href="https://www.facebook.com/N2Xpress-102848644944867" target="_blank" class="social-link w-inline-block"><img src="assets/images/FB.png" loading="lazy" width="32" height="32" alt="n2xpress - Send money across borders, the easy way - Facebook"></a>
            <a href="https://twitter.com/N2xpress" target="_blank" class="social-link w-inline-block"><img src="assets/images/Twitter.png" loading="lazy" width="32" height="32" alt="n2xpress - Send money across borders, the easy way - Twitter"></a>
            <a href="https://www.youtube.com/channel/UCwobyc5RQliVRDB37ZthVsw" target="_blank" class="social-link w-inline-block"><img src="assets/images/Youtube.png" loading="lazy" width="32" height="32" alt="n2xpress - Send money across borders, the easy way - Youtube"></a>
            <a href="https://www.linkedin.com/company/n2xpress" target="_blank" class="social-link w-inline-block"><img src="assets/images/Linkedin.png" loading="lazy" width="32" height="32" alt="n2xpress - Send money across borders, the easy way - Linkedin"></a>
            <a href="https://www.instagram.com/n2xpress/" target="_blank" class="social-link w-inline-block"><img src="assets/images/Instagram.png" loading="lazy" width="32" height="32" alt="n2xpress - Send money across borders, the easy way - Instagram"></a>
          </div>
        </div>
        <div class="col-md-6 d-flex d-md-none flex-column align-items-start justify-content-end">
          <a target="_blank" href="https://play.google.com/store/apps/details?id=com.n2xpress.app"><img src="assets/images/google-play.png"  class="footer-playStore" alt=""></a>
          <a class="cursor-pointer" href="https://apps.apple.com/in/app/n2xpress-money-transfer/id1570971775" target="blank">
            <img  src="assets/images/apple_store.png" class="footer-appleStore  m-1" alt="">
          </a>
        </div>
      </div>
      <div class="mt-3 d-flex flex-column d-md-none">
        <div class="row mx-0">
          <h6 class="primary-text sm-16 font-weight-bold my-3">Send money</h6>
        </div>
        <div class="row mx-0">
          <div class="col-md-6">
            <div class="row">
              <a [routerLink]="['/cad-to-inr']" class="custom-footer-link w-inline-block">
                <div class="text-block-29">CAD to INR</div>
              </a>
            </div>
            <div class="row">
              <a [routerLink]="['/cad-to-ngn']" class="custom-footer-link w-inline-block">
                <div class="text-block-29">CAD to NGN</div>
              </a>
            </div>
            <div class="row">
              <a [routerLink]="['/cad-to-kes']" class="custom-footer-link w-inline-block">
                <div class="text-block-29">CAD to KES</div>
              </a>
            </div>
            <div class="row">
              <a [routerLink]="['/cad-to-ghs']" class="custom-footer-link w-inline-block">
                <div class="text-block-29">CAD to GHS</div>
              </a>
            </div>
            <div class="row">
              <a [routerLink]="['/cad-to-xof']" class="custom-footer-link w-inline-block">
                <div class="text-block-29">CAD to XOF</div>
              </a>
            </div>
            <div class="row">
              <a [routerLink]="['/cad-to-php']" class="custom-footer-link w-inline-block">
                <div class="text-block-29">CAD to PHP</div>
              </a>
            </div>
            <div class="row">
              <a [routerLink]="['/cad-to-zar']" class="custom-footer-link w-inline-block">
                <div class="text-block-29">CAD to ZAR</div>
              </a>
            </div>
          </div>
          <!-- <div class="col-md-6"> -->
            <!-- <div class="row">
              <a [routerLink]="['/usd-to-inr']" class="custom-footer-link w-inline-block">
                <div class="text-block-29">USD to INR</div>
              </a>
            </div> -->
            <!-- <div class="row">
              <a [routerLink]="['/usd-to-ghs']" class="custom-footer-link w-inline-block">
                <div class="text-block-29">USD to GHS</div>
              </a>
            </div> -->
            <!-- <div class="row">
              <a [routerLink]="['/usd-to-kes']" class="custom-footer-link w-inline-block">
                <div class="text-block-29">USD to KES</div>
              </a>
            </div> -->
          <!-- </div> -->
        </div>
      </div>
    </div>
    
  </div>
  <div class="w-container">
    <div class="text-block-27 my-3">N2Xpress is a trading name of Alpha Fortress Ltd. © 2020 Alpha Fortress Limited. All Rights Reserved.Alpha Fortress Ltd. is a Money Service Business regulated by the Financial Transactions and Reports Analysis Centre of Canada (FINTRAC) registered under Money Laundering Regulations number M20789402.</div>
  </div>
</div>
